import { render, staticRenderFns } from "./ConfigReceiverEmail.vue?vue&type=template&id=93f80210&"
import script from "./ConfigReceiverEmail.vue?vue&type=script&lang=js&"
export * from "./ConfigReceiverEmail.vue?vue&type=script&lang=js&"
import style0 from "./ConfigReceiverEmail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports